import React, { useState, useEffect } from "react";
import { navigate, usePath } from "hookrouter";
import { Logo, colors, sans } from "../../theme/brand";
import useMediaQuery from "../../hooks/useMediaQuery";

const links = [
  { path: "/diensten", label: "Diensten" },
  { path: "/over-ons", label: "Over ons" },
  { path: "/contact", label: "Contact" },
];

const navStyle = (active) => ({
  background: active ? "#E7E0D0" : "none",
  border: "none",
  cursor: "pointer",
  fontFamily: sans,
  fontSize: 15.5,
  fontWeight: 600,
  padding: "9px 15px",
  borderRadius: 999,
  color: active ? colors.ink : "#7C8288",
});

const mobileLinkStyle = (active) => ({
  ...navStyle(active),
  width: "100%",
  textAlign: "left",
  fontSize: 17,
  padding: "13px 16px",
});

function HamburgerIcon({ open }) {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke={colors.ink} strokeWidth="2" strokeLinecap="round">
      {open ? (
        <>
          <line x1="5" y1="5" x2="19" y2="19" />
          <line x1="19" y1="5" x2="5" y2="19" />
        </>
      ) : (
        <>
          <line x1="3" y1="7" x2="21" y2="7" />
          <line x1="3" y1="12" x2="21" y2="12" />
          <line x1="3" y1="17" x2="21" y2="17" />
        </>
      )}
    </svg>
  );
}

export default function AppNavigation() {
  const path = usePath();
  const isMobile = useMediaQuery("(max-width: 760px)");
  const [open, setOpen] = useState(false);

  // Collapse the mobile menu whenever we grow back to desktop.
  useEffect(() => {
    if (!isMobile) setOpen(false);
  }, [isMobile]);

  const go = (p) => {
    setOpen(false);
    navigate(p);
  };

  return (
    <nav
      style={{
        position: "sticky",
        top: 0,
        zIndex: 50,
        background: colors.cream,
        borderBottom: `1px solid ${colors.border}`,
      }}
    >
      <div
        style={{
          maxWidth: 1120,
          margin: "0 auto",
          padding: "18px 32px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: 24,
        }}
      >
        <button
          onClick={() => go("/")}
          style={{
            display: "flex",
            alignItems: "center",
            gap: 9,
            background: "none",
            border: "none",
            cursor: "pointer",
            fontFamily: sans,
          }}
        >
          <Logo size={24} />
          <span style={{ fontSize: 20, fontWeight: 700, letterSpacing: "-0.01em", color: colors.ink }}>
            Datails
          </span>
        </button>

        {!isMobile && (
          <>
            <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
              {links.map(({ path: p, label }) => (
                <button key={p} onClick={() => go(p)} style={navStyle(path === p)}>
                  {label}
                </button>
              ))}
            </div>
            <a
              href="mailto:info@datails.nl"
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: 8,
                background: colors.ink,
                color: colors.cream,
                padding: "11px 20px",
                borderRadius: 999,
                fontSize: 14.5,
                fontWeight: 600,
              }}
            >
              Mail ons
            </a>
          </>
        )}

        {isMobile && (
          <button
            onClick={() => setOpen((v) => !v)}
            aria-label="Menu"
            aria-expanded={open}
            style={{
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              background: "none",
              border: "none",
              cursor: "pointer",
              padding: 6,
            }}
          >
            <HamburgerIcon open={open} />
          </button>
        )}
      </div>

      {isMobile && open && (
        <div
          style={{
            borderTop: `1px solid ${colors.border}`,
            background: colors.cream,
            padding: "12px 24px 20px",
            display: "flex",
            flexDirection: "column",
            gap: 4,
          }}
        >
          {links.map(({ path: p, label }) => (
            <button key={p} onClick={() => go(p)} style={mobileLinkStyle(path === p)}>
              {label}
            </button>
          ))}
          <a
            href="mailto:info@datails.nl"
            onClick={() => setOpen(false)}
            style={{
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              gap: 8,
              background: colors.ink,
              color: colors.cream,
              padding: "13px 20px",
              borderRadius: 999,
              fontSize: 15.5,
              fontWeight: 600,
              marginTop: 8,
            }}
          >
            Mail ons
          </a>
        </div>
      )}
    </nav>
  );
}
